import * as React from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { DubitoSvc } from "../../api";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Icon,
  Avatar,
  IconButton,
  TablePagination,
  Tabs,
  Tab,
  Chip,
  Badge,
  Card,
  createStyles,
  withStyles,
  LinearProgress,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormLabel
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import * as moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";

import EnhancedTable from "./table";
import { Case, User, Category, Tag } from "../../api/classes";
//import cookie from 'react-cookie'
import FilterListIcon from "@material-ui/icons/FilterList";
import SortIcon from "@material-ui/icons/SwapVert";
import ExportIcon from "@material-ui/icons/CloudDownload";

import { connect, Dispatch } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import Select from "react-select";
import FilterView from "../../components/filter";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import DatePicker from "material-ui-pickers/DatePicker";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import { CSVLink } from "react-csv";
import { Link, RouteComponentProps } from "react-router-dom";
import Loading from "../../components/loading";
import AddCaseButton from "./components/addCaseButton";
import EmptyState from "src/components/emptyState";
import queryString from "query-string";
import {
  FOLDER_NEWS_FEED,
  Permissions,
  STARRED_TAG_ID
} from "src/api/constants";
import { TablePaginationActionsWrapped } from "src/components/tablePaginationActions";
import { clearInterval } from "timers";
import Sort from "./components/sort";
import UserSelect from "src/components/userSelect";
import { openSnack } from "src/util/util";
import { updateCase } from "src/store/db";
import StatusSelect from "src/components/statusSelect";
import { DEFAULT_AVATAR, hasPermissionOf } from "src/auth/auth";
import StarIcon from "@material-ui/icons/Star";

interface Props extends RouteComponentProps<{}> {
  classes: any;
  cases: Case[];
  users: User[];
  categories: Category[];
  tags: Tag[];
  fetchCases: () => void;
  fetchUpdatedCases: () => void;
  fetchUsers: () => void;
  fetchCategories: () => void;
  fetchTags: () => void;
  updateCaseLocal: (_case: Case) => void;
  updateRequired: boolean;
  cacheLoaded: boolean;
}
interface State {
  cases: Case[];
  page: number;
  rowsPerPage: number;
  filterOpen: boolean;
  sortOpen: boolean;
  loading: boolean;
}
function CustomTab(props: ButtonBaseProps) {
  return (
    <div>
      {props.children} + {props.title}
    </div>
  );
}
const styles = theme =>
  createStyles({
    toolbar: {
      flexWrap: "wrap",
      justifyContent: "flex-end",
      marginBottom: 8,
      marginTop: 8
    }
  });
const statusItems = [
  {
    label: "In Progress",
    value: "in_progress",
    backgroundColor: "#ff5722",
    color: "#ffffff"
  },
  {
    label: "Pending",
    value: "pending",
    backgroundColor: "#ff9800",
    color: "#ffffff"
  },
  {
    label: "No Analysis",
    value: "no_analysis",
    backgroundColor: "darkslategray",
    color: "#ffffff"
  },
  {
    label: "Verified",
    value: "verified",
    backgroundColor: "green",
    color: "#ffffff"
  }
];
class CaseList extends React.Component<Props> {
  lastSearch: NodeJS.Timer;
  state = {
    cases: this.props.cases,
    page: 0,
    rowsPerPage: 25,
    filterOpen: localStorage.getItem("filterOpen") === "true",
    sortOpen: false,
    userFilters: [],
    stateFilters: [],
    categoryFilters: [],
    tagFilters: [],
    folder: "news_feed",
    startDate: null,
    endDate: null,
    loading: false,
    tagIds: [],
    caseListUpdated: false,
    q: "",
    sortDirection: "desc",
    sortBy: "date",
    showStarred: false
  };
  componentDidMount() {
    //console.log("list did mount!");
    if (!this.props.cases && this.props.cacheLoaded) {
      this.props.fetchCases();
    } else if (this.props.cacheLoaded && this.props.updateRequired) {
      this.props.fetchUpdatedCases();
    }
    if (!this.props.users) {
      this.props.fetchUsers();
    }
    if (!this.props.categories) {
      this.props.fetchCategories();
    }
    if (!this.props.tags) {
      this.props.fetchTags();
    }
    if (
      this.props.categories &&
      this.props.users &&
      this.props.cases &&
      this.props.tags
    ) {
      //console.log("list parse query");
      this.parseQueryString(this.props);
    }
  }
  componentWillReceiveProps(next: Props) {
    if (
      (!this.props.categories ||
        !this.props.users ||
        !this.props.cases ||
        !this.props.tags) &&
      next.categories &&
      next.users &&
      next.cases &&
      next.tags
    ) {
      // this.parseQueryString(next);
    }
    if (next.cacheLoaded && !this.state.caseListUpdated) {
      this.props.fetchUpdatedCases();
      this.setState({ cases: next.cases, caseListUpdated: true });
    } else {
      if (next.cases) {
        this.setState({ cases: next.cases }, () => {
          this.filterCases();
        });
      }
    }
  }
  parseQueryString = (props: Props) => {
    const query = queryString.parse(props.location.search);
    //console.log(query);
    let userFilters = [],
      categoryFilters = [],
      tagFilters = [],
      stateFilters = [],
      page = 0,
      rowsPerPage = 25,
      q = "",
      folder = FOLDER_NEWS_FEED,
      sortBy = "date",
      sortDirection = "desc",
      showStarred = false,
      startDate = null,
      endDate = null;
    if (query.folder) {
      folder = query.folder;
    }
    if (query.page) {
      page = parseInt(query.page);
    }
    if (query.rowsPerPage) {
      rowsPerPage = parseInt(query.rowsPerPage);
    }
    if (query.q) {
      q = query.q;
    }
    if (query.sortBy) {
      sortBy = query.sortBy;
    }
    if (query.dir) {
      sortDirection = query.dir;
    }
    if (query.after) {
      startDate = moment(query.after, "DD-MM-YYYY").toISOString();
    }
    if (query.before) {
      endDate = moment(query.before, "DD-MM-YYYY").toISOString();
      //console.log("parse query before", endDate);
    }
    if (query.category) {
      const cats = query.category.split(",") as string[];
      categoryFilters = cats.reduce(
        (accumulator, currentValue, currentIndex, array: any[]) => {
          const c = props.categories.find(c => c.title === currentValue);
          if (c) {
            accumulator.push({ label: currentValue, value: c.id });
            return accumulator;
          }
          return accumulator;
        },
        []
      );
    }
    if (query.starred) {
      showStarred = query.starred === "true";
    }
    if (query.tag) {
      const tags = query.tag.split(",") as string[];
      tagFilters = tags.reduce(
        (accumulator, currentValue, currentIndex, array: any[]) => {
          const c = props.tags.find(c => c.title === currentValue);
          if (c) {
            accumulator.push({ label: currentValue, value: c.id });
            return accumulator;
          }
          return accumulator;
        },
        []
      );
      console.warn("showStarred", showStarred);
    }
    if (
      (!this.state.loading &&
        JSON.stringify(this.state.tagFilters) !== JSON.stringify(tagFilters)) ||
      showStarred !== this.state.showStarred
    ) {
      this.getTagCases(tagFilters, showStarred);
    }

    if (query.status) {
      const statuses = query.status.split(",") as string[];
      stateFilters = statuses.reduce(
        (accumulator, currentValue, currentIndex, array: any[]) => {
          const c = statusItems.find(c => c.label === currentValue);
          if (c) {
            accumulator.push(c);
            return accumulator;
          }
          return accumulator;
        },
        []
      );
    }
    if (query.user) {
      const users = query.user.split(",") as string[];
      userFilters = users.reduce(
        (accumulator, currentValue, currentIndex, array: any[]) => {
          const c = props.users.find(c => c.id === parseInt(currentValue));
          if (c) {
            accumulator.push({
              label: c.name,
              value: c.id,
              avatar: c.account_picture || DEFAULT_AVATAR
            });
            return accumulator;
          }
          return accumulator;
        },
        []
      );
    }
    this.setState(
      {
        categoryFilters,
        tagFilters,
        stateFilters,
        userFilters,
        page,
        rowsPerPage,
        folder,
        q,
        sortBy,
        sortDirection,
        showStarred,
        startDate,
        endDate
      },
      () => {
        //console.log("filter from parse");
        this.filterCases();
      }
    );
  };
  handleChangePage = (event, page) => {
    this.setState({ page }, () => this.generateQuery());
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value }, () =>
      this.generateQuery()
    );
  };
  toggleFilterView = () => {
    localStorage.setItem("filterOpen", !this.state.filterOpen + "");
    this.setState({ filterOpen: !this.state.filterOpen, sortOpen: false });
  };
  toggleSortView = () => {
    this.setState({ sortOpen: !this.state.sortOpen, filterOpen: false });
  };
  renderSort() {
    if (this.state.sortOpen) {
      return (
        <Sort
          direction={this.state.sortDirection}
          by={this.state.sortBy}
          onChange={(by, direction) => {
            //console.log("sortBy", by, "sortDirection", direction);
            this.setState({ sortBy: by, sortDirection: direction }, () => {
              this.generateQuery();
              this.sortCases(this.state.cases);
            });
          }}
        />
      );
    }
    return null;
  }
  generateQuery() {
    const obj = {} as any;
    if (this.state.q && this.state.q !== "") {
      obj.q = this.state.q;
    }
    if (this.state.categoryFilters.length > 0) {
      const string = this.state.categoryFilters.map(i => i.label).join(",");
      obj.category = string;
    }
    if (this.state.folder !== FOLDER_NEWS_FEED) {
      obj.folder = this.state.folder;
    }
    if (this.state.page > 0) {
      obj.page = this.state.page;
    }
    if (this.state.rowsPerPage !== 25) {
      obj.rowsPerPage = this.state.rowsPerPage;
    }
    if (this.state.stateFilters.length > 0) {
      const string = this.state.stateFilters.map(i => i.label).join(",");
      obj.status = string;
    }
    if (this.state.userFilters.length > 0) {
      const string = this.state.userFilters.map(i => i.value).join(",");
      obj.user = string;
    }
    if (this.state.tagFilters.length > 0) {
      const string = this.state.tagFilters.map(i => i.label).join(",");
      obj.tag = string;
    }
    if (this.state.sortBy !== "date") {
      obj.sortBy = this.state.sortBy;
    }
    if (this.state.sortDirection !== "desc") {
      obj.dir = this.state.sortDirection;
    }
    if (this.state.startDate !== null) {
      obj.after = moment(this.state.startDate).format("DD-MM-YYYY");
    }
    if (this.state.endDate !== null) {
      obj.before = moment(this.state.endDate).format("DD-MM-YYYY");
      //console.log("query before", obj.before);
    }
    //window.location.search = queryString.stringify(obj);
    /*    this.props.history.replace({
      pathname: "/cases",
      search: queryString.stringify(obj)
    }); */
    if (this.state.showStarred) {
      obj.starred = "true";
    }
    if (
      queryString.stringify(queryString.parse(this.props.location.search)) !==
      queryString.stringify(obj)
    ) {
      this.props.history.replace({
        pathname: "/cases",
        search: queryString.stringify(obj)
      });
    }

    /*  window.history.replaceState({
        pathname: "/cases",
        search: queryString.stringify(obj)
      }); */
    //console.log(queryString.stringify(obj));
  }
  sortCases(caseList?: Case[]) {
    if (!caseList) {
      return;
    }
    let compareFn: (a, b) => number;
    if (this.state.sortBy === "date") {
      if (this.state.sortDirection === "asc") {
        compareFn = (a, b) => {
          return moment(a.created_at).unix() - moment(b.created_at).unix();
        };
      } else if (this.state.sortDirection === "desc") {
        compareFn = (a, b) => {
          return moment(b.created_at).unix() - moment(a.created_at).unix();
        };
      }
    }
    if (this.state.sortBy === "reportCount") {
      if (this.state.sortDirection === "asc") {
        compareFn = (a: Case, b: Case) => {
          return a.report_count - b.report_count;
        };
      } else if (this.state.sortDirection === "desc") {
        compareFn = (a, b) => {
          return b.report_count - a.report_count;
        };
      }
    }

    this.setState({ cases: caseList.sort(compareFn) }, () => {
      //console.log("sorted!");
    });
  }
  filterCases() {
    this.generateQuery();
    let cases = this.props.cases.copyWithin(0, 0);
    const {
      userFilters,
      stateFilters,
      categoryFilters,
      tagFilters,
      q
    } = this.state;
    if (q.length !== 0) {
      cases = cases.filter(c => {
        if (q.length > 0) {
          return (
            c.title.toLocaleLowerCase().indexOf(q.toLocaleLowerCase()) > -1
          );
        }
      });
    }
    if (userFilters.length !== 0) {
      cases = cases.filter(c => {
        if (userFilters.length > 0) {
          if (userFilters.find(u => u.value === c.user_id)) {
            return true;
          }
        }
      });
    }
    if (stateFilters.length !== 0) {
      cases = cases.filter(c => {
        if (stateFilters.length > 0) {
          if (stateFilters.find(u => u.value === c.status)) {
            return true;
          }
        }
      });
    }
    if (categoryFilters.length !== 0) {
      cases = cases.filter(c => {
        if (categoryFilters.length > 0) {
          if (categoryFilters.find(u => u.value === c.category_id)) {
            return true;
          }
        }
      });
    }
    if (tagFilters.length !== 0 || this.state.showStarred) {
      cases = cases.filter(c => {
        if (tagFilters.length > 0 || this.state.showStarred) {
          if (
            this.state.tagIds.find(u => u === c.id) ||
            (this.state.showStarred && c.id === STARRED_TAG_ID)
          ) {
            return true;
          }
        }
      });
    }
    if (this.state.startDate !== null) {
      cases = cases.filter(c => {
        if (moment(c.created_at).isAfter(this.state.startDate)) {
          return true;
        }
      });
    }
    if (this.state.endDate !== null) {
      cases = cases.filter(c => {
        if (moment(c.created_at).isBefore(this.state.endDate)) {
          return true;
        }
      });
    }
    this.sortCases(cases);
    // this.setState({ cases });
  }
  getTagCases = (tags: any[], showStarred: boolean) => {
    if (tags.length === 0 && !showStarred) {
      return;
    }
    this.setState({ loading: true });

    const ids = tags.map(t => t.value);

    if (showStarred) {
      ids.push(STARRED_TAG_ID);
    }
    DubitoSvc.getTagCases({ tag_ids: ids }).then(res => {
      this.setState({ tagIds: res, loading: false });
      this.filterCases();
      //console.log(res);
    });
  };
  renderFilter() {
    if (!this.props.users) {
      return;
    }
    const userIDs = this.props.cases.map(i => {
      return i.user_id;
    });
    const users = this.props.users
      .filter(i => {
        return userIDs.find(e => e === i.id);
      })
      .map(i => ({
        label: i.name,
        value: i.id,
        avatar: i.account_picture || DEFAULT_AVATAR
      }));
    const cats = this.props.categories.map(c => ({
      label: c.title,
      value: c.id
    }));
    const tags = this.props.tags.map(c => ({
      label: c.title,
      value: c.id
    }));
    if (this.state.filterOpen) {
      return (
        <div style={{}}>
          <Card style={{ marginTop: 24, marginBottom: 24, padding: 24 }}>
            <TextField
              label="Title"
              InputLabelProps={{
                shrink: true
              }}
              placeholder="Enter part of case title"
              fullWidth
              style={{ marginBottom: 16 }}
              value={this.state.q}
              onChange={e => {
                this.setState({ q: e.target.value }, () => {
                  if (this.lastSearch) {
                    clearTimeout(this.lastSearch);
                  }
                  this.lastSearch = setTimeout(() => {
                    this.filterCases();
                  }, 300);
                });
              }}
            />
            <FilterView
              theme
              suggestions={users}
              title="Assignee"
              placeholder="Select users like Mark, Can, Atakan"
              values={this.state.userFilters}
              onChange={(values: any[]) => {
                //console.log(values);
                this.setState({ userFilters: values }, () => {
                  this.filterCases();
                  // this.generateQuery();
                });
              }}
            />
            <div style={{ margin: 16 }} />
            <FilterView
              theme
              values={this.state.stateFilters}
              suggestions={statusItems}
              title="Status"
              placeholder="In Progress, Pending, No Analysis, Verified"
              onChange={(values: any[]) => {
                //console.log(values);
                this.setState({ stateFilters: values }, () => {
                  this.filterCases();
                });
              }}
            />
            <div style={{ margin: 16 }} />
            <FilterView
              theme
              values={this.state.categoryFilters}
              suggestions={cats}
              title="Categories"
              placeholder="Life, Politics"
              onChange={(values: any[]) => {
                //console.log(values);
                this.setState({ categoryFilters: values }, () => {
                  this.filterCases();
                });
              }}
            />
            <div style={{ margin: 16 }} />
            <FilterView
              theme
              values={this.state.tagFilters}
              suggestions={tags}
              title="Tags"
              placeholder="#Syria, #Obama"
              onChange={(values: any[]) => {
                //console.log(values);
                this.setState({ tagFilters: values }, () => {
                  this.getTagCases(values, this.state.showStarred);
                });
              }}
            />
            <FormControlLabel
              style={{ marginTop: 12 }}
              control={
                <Checkbox
                  color="primary"
                  checked={this.state.showStarred}
                  onChange={(e, v) =>
                    this.setState({ showStarred: v }, () => {
                      this.getTagCases(this.state.tagIds, v);
                    })
                  }
                />
              }
              label={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                  }}
                >
                  {"With Star"}
                  <StarIcon />
                </div>
              }
            />
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end"
                }}
              >
                <Typography
                  variant="caption"
                  style={{ fontSize: 16, marginBottom: 5 }}
                >
                  From
                </Typography>
                <DatePicker
                  clearable
                  style={{
                    marginLeft: 16,
                    marginRight: 16,
                    textAlign: "center"
                  }}
                  format="LL"
                  placeholder="Day 0"
                  value={this.state.startDate}
                  onChange={m => {
                    this.setState(
                      { startDate: m ? m.toISOString() : null },
                      () => this.filterCases()
                    );
                  }}
                />
                <Typography
                  variant="caption"
                  style={{ fontSize: 16, marginBottom: 5 }}
                >
                  Until
                </Typography>

                <DatePicker
                  clearable
                  placeholder="Today"
                  style={{ marginLeft: 16 }}
                  format="LL"
                  value={this.state.endDate}
                  onChange={m => {
                    this.setState({ endDate: m ? m.toISOString() : null }, () =>
                      this.filterCases()
                    );
                  }}
                />
              </div>
            </MuiPickersUtilsProvider>
          </Card>
          <Divider />
        </div>
      );
    }
    return null;
  }
  handleTabChange = (event, value) => {
    this.setState({ folder: value }, () => {
      this.generateQuery();
    });
  };
  get filterCount() {
    let count =
      this.state.stateFilters.length +
      this.state.userFilters.length +
      this.state.categoryFilters.length;

    if (this.state.startDate) {
      count++;
    }
    if (this.state.endDate) {
      count++;
    }
    return count;
  }
  render() {
    if (
      !this.state.cases ||
      !this.props.categories ||
      !this.props.tags ||
      !this.props.users
    ) {
      if (this.props.cacheLoaded) {
        return (
          <Loading text="New here? It may take a while to load for the first time" />
        );
      }
      return <Loading />;
    }
    const canEdit = hasPermissionOf(Permissions.EDIT_CASES);
    const { cases, rowsPerPage, page } = this.state;
    const pagination = (
      <TablePagination
        style={{ flex: 1 }}
        component="div"
        classes={{ toolbar: this.props.classes.toolbar }}
        count={cases.filter(c => c.folder === this.state.folder).length}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        page={page}
        backIconButtonProps={{
          "aria-label": "Previous Page"
        }}
        nextIconButtonProps={{
          "aria-label": "Next Page"
        }}
        onChangePage={this.handleChangePage}
        onChangeRowsPerPage={this.handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActionsWrapped as any}
      />
    );
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          paddingBottom: 96,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "scroll"
        }}
      >
        {/*         <EnhancedTable data={this.state.cases} />
         */}
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            marginLeft: 24,
            marginRight: 24
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap-reverse"
            }}
          >
            <div style={{ flexShrink: 1, flexGrow: 1 }}>
              <Tabs
                value={this.state.folder}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                scrollable
                scrollButtons="off"
              >
                <Tab
                  label={
                    <div>
                      News Feed
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12
                        }}
                        label={
                          this.state.cases.filter(i => i.folder === "news_feed")
                            .length
                        }
                      />
                    </div>
                  }
                  value="news_feed"
                />
                <Tab
                  label={
                    <div>
                      Cold Cases
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12
                        }}
                        label={
                          this.state.cases.filter(
                            i => i.folder === "cold_cases"
                          ).length
                        }
                      />
                    </div>
                  }
                  value="cold_cases"
                />
                <Tab
                  label={
                    <div>
                      Archive
                      <Chip
                        style={{
                          marginLeft: 4,
                          height: 24,
                          fontSize: 12
                        }}
                        label={
                          this.state.cases.filter(i => i.folder === "archive")
                            .length
                        }
                      />
                    </div>
                  }
                  value="archive"
                />
              </Tabs>
            </div>
            <div style={{ flexGrow: 1 }} />
            {canEdit && (
              <CSVLink data={this.state.cases}>
                <IconButton aria-label="Download">
                  <ExportIcon />
                </IconButton>
              </CSVLink>
            )}
            <IconButton aria-label="Filter list" onClick={this.toggleSortView}>
              <SortIcon />
            </IconButton>
            <Badge badgeContent={this.filterCount} color="primary">
              <IconButton
                aria-label="Filter list"
                onClick={this.toggleFilterView}
              >
                <FilterListIcon />
              </IconButton>
            </Badge>
          </div>
          <Divider />
          {this.renderSort()}
          {this.renderFilter()}
          {pagination}
          {(this.props.updateRequired || this.state.loading) && (
            <LinearProgress />
          )}
          <List>
            {this.props.cases.length === 0 && (
              <EmptyState message="There is no case yet. You may create one by pressing + icon at the bottom." />
            )}
            {this.state.cases
              .filter(c => c.folder === this.state.folder)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((i: Case) => {
                return (
                  <ListItem
                    key={i.id}
                    style={{
                      paddingTop: 24,
                      paddingLeft: 8,
                      paddingRight: 8,
                      paddingBottom: 0
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column"
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center"
                        }}
                      >
                        <Link
                          key={i.id}
                          to={"/case/" + i.id}
                          style={{ flex: 1, textDecoration: "none" }}
                        >
                          <Typography
                            variant="body1"
                            style={{ flex: 1, fontSize: 16 }}
                          >
                            <u>{i.title}</u>
                          </Typography>
                        </Link>
                        {/*                      <StatusSelect
                          value={i.status}
                          onSelect={this.setStatus(i)}
                        /> */}
                        {this.renderStatus(i.status)}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                          marginTop: 12
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            flex: 1
                          }}
                        >
                          <Typography variant="caption">#{i.id}</Typography>
                          <Typography
                            style={{ marginLeft: 8 }}
                            variant="caption"
                          >
                            {"opened " +
                              moment(i.created_at).format(
                                "dddd, DD MMMM YYYY, HH:mm"
                              )}
                          </Typography>
                          <Typography
                            style={{ marginLeft: 8 }}
                            variant="caption"
                          >
                            {i.report_count + " Reports"}
                          </Typography>
                          <UserSelect
                            small
                            style={{ marginLeft: 16, zIndex: 50 }}
                            id={i.user_id}
                            readOnly={!hasPermissionOf(Permissions.EDIT_CASES)}
                            onSelect={this.setAssignee(i)}
                          />
                        </div>
                        {this.renderCategory(i.category_id)}
                      </div>
                      <Divider />
                    </div>
                  </ListItem>
                );
              })}
          </List>
          {pagination}
          <AddCaseButton />
        </div>
      </div>
    );
  }
  setStatus = (_case: Case) => status => {
    if (_case.status !== status) {
    }
  };
  setAssignee = (_case: Case) => user_id => {
    if (_case.user_id !== user_id) {
      DubitoSvc.setCaseAssignee({ case_id: _case.id, assignee: user_id })
        .then(() => {
          openSnack("Case Updated!", "success");
          _case.user_id = user_id;
          this.props.updateCaseLocal(_case);
          this.props.fetchUpdatedCases();
        })
        .catch(() => {
          openSnack("Case Update Failed!", "error");
        });
    }
  };

  renderCategory(category_id) {
    let text = category_id;
    if (this.props.categories) {
      const cat = this.props.categories.find(i => i.id === category_id);
      if (cat) {
        text = cat.title;
      }
    }
    return (
      <Typography style={{ marginLeft: 8 }} variant="body2">
        {text}
      </Typography>
    );
  }
  renderUser(user_id) {
    const user =
      this.props.users && this.props.users.find(e => e.id === user_id);
    if (user) {
      return (
        <div style={{ display: "flex", flexDirection: "row", marginLeft: 12 }}>
          <Avatar
            style={{ width: 20, height: 20 }}
            src={user.account_picture || DEFAULT_AVATAR}
          />
          <Typography style={{ marginLeft: 8, fontSize: 13 }} variant="body2">
            {user.name}
          </Typography>
        </div>
      );
    } else {
      return null;
    }
  }
  renderStatus(status) {
    let color = "#ffffff00",
      text = "status";
    if (status === "pending") {
      color = "#ff9800";
      text = "Pending";
    } else if (status === "in_progress") {
      color = "#ff5722";
      text = "In Progress";
    } else if (status === "no_analysis") {
      color = "darkslategray";
      text = "No Analysis";
    } else if (status === "verified") {
      color = "green";
      text = "Verified";
    }
    return (
      <Typography
        style={{
          marginLeft: 16,
          backgroundColor: color,
          color: "white",
          padding: 2,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: 6,
          fontSize: 14
        }}
        variant="caption"
      >
        {text}
      </Typography>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    cases: state.cases.list,
    users: state.cases.users,
    categories: state.cases.categories,
    tags: state.cases.tags,
    updateRequired: state.cases.casesUpdateRequired,
    cacheLoaded: state.cases.cacheLoaded
  }),
  dispatch => ({
    fetchCases: (): any => dispatch(actions.fetchCases()),
    updateCaseLocal: (_case: Case): any =>
      dispatch(actions.updateCaseLocal(_case)),
    fetchUpdatedCases: (): any => dispatch(actions.fetchUpdatedCases()),
    fetchUsers: (): any => dispatch(actions.fetchUsers()),
    fetchCategories: (): any => dispatch(actions.fetchCategories()),
    fetchTags: (): any => dispatch(actions.fetchTags())
  })
)(withStyles(styles)(CaseList));



// WEBPACK FOOTER //
// ./src/pages/cases/list.tsx